import React from 'react';

const Footer = () => {
    return (
        <div>
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-md-3 footer-item">
                        <h4>Our Contacts </h4>
                        <ul className="social-icons">
                        <li><a href="https://www.facebook.com/profile.php?id=61554206397116&locale=fr_FR"><i className="fa fa-facebook"></i></a></li>
                                <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                                <li><a href="mailto:creative.lab.club@gmail.com"><i className="fa fa-envelope"></i></a></li> 
                                <li><a href="https://www.instagram.com/creative_lab_isi/"><i className="fa fa-instagram"></i></a></li> 
                                
                            
                        </ul>
                    </div>
                  
                    <div className="col-md-3 footer-item">
                        <h4>Additional Pages</h4>
                        <ul className="menu-list">
                            <li><a href="/AboutUs">About Us</a></li>
                            <li><a href="/OurServices">How We Work</a></li>
                            <li><a href="/ContactUs">Quick Support</a></li>
                            <li><a href="/ContactUs">Contact Us</a></li>
                            <li><a href="/PrivacyPolicy">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <div className="col-md-3 footer-item last-item">
                        <h4>Contact Us</h4>
                        <div className="contact-form">
                            <form id="contact" className="footer-contact" action="" method="post">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <fieldset>
                                            <input name="name" type="text" className="form-control" id="name" placeholder="Full Name" required />
                                        </fieldset>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <fieldset>
                                            <input name="email" type="text" className="form-control" id="email" pattern="[^ @]*@[^ @]*" placeholder="E-Mail Address" required />
                                        </fieldset>
                                    </div>
                                    <div className="col-lg-12">
                                        <fieldset>
                                            <textarea name="message" rows="6" className="form-control" id="message" placeholder="Your Message" required></textarea>
                                        </fieldset>
                                    </div>
                                    <div className="col-lg-12">
                                        <fieldset>
                                            <button type="submit" id="form-submit" className="filled-button">Send Message</button>
                                        </fieldset>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
       
        </footer>
             <div className="sub-footer">
             <div className="container">
               <div className="row">
                 <div className="col-md-12">
                   <p> © Designed Creative Lab 2025/2026</p>
                 </div>
               </div>
             </div>
           </div>
           </div>
    );
};

export default Footer;
